import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 62D729FA-8643-4FAF-9D2D-176AE4ED3774
 * name format-letter-matches
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-letter-matches.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatLetterMatchesIcon = createSvgIcon(<><path d="M11.14 4L6.43 16H8.36L9.32 13.43H14.67L15.64 16H17.57L12.86 4M12 6.29L14.03 11.71H9.96M20 14V18H4V15H2V20H22V14Z" /></>, 'FormatLetterMatchesIcon');
export default FormatLetterMatchesIcon